import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import Accessibility from 'highcharts/modules/accessibility'
import Annotations from 'highcharts/modules/annotations'
import Sankey from 'highcharts/modules/sankey'
import Stock from 'highcharts/modules/stock'
import Maps from 'highcharts/modules/map'
import HighchartsVue from 'highcharts-vue'
import {defineNuxtPlugin} from 'nuxt/app'

export default defineNuxtPlugin(nuxtApp => {
  Maps(Highcharts)
  Stock(Highcharts)
  Sankey(Highcharts)
  Annotations(Highcharts)
  Accessibility(Highcharts)
  HighchartsMore(Highcharts)

  Highcharts.setOptions({
    lang: {
      thousandsSep: ',',
      numericSymbols: ['K', 'M', 'B', 'T', 'P', 'E'],
    },
    credits: {enabled: false},
    chart: {
      style: {
        fontFamily: '\'Inter\', \'Noto Sans KR\', sans-serif',
      },
    },
  })

  nuxtApp.vueApp.use(HighchartsVue as any)
})